import React, { Component } from "react";

import Base from "../../../components/Base";
import { Checkbox, Row, Col, Button, Modal } from "antd";

import api from "../../../services/api";
import handleError from "../../../services/apiErrorHandler";

import "../styles.css";

export default class Buscainfo extends Component {
  state = {
    data: {},
    loading: false
  };

  handleExecutar = async () => {
    const file = document.getElementById("planilha").files[0];

    if (file == null) {
      Modal.error({
        title: "Erro",
        content: "Selecione a planilha de entrada!"
      });
      return;
    }

    /** Checa se possui alguma opção marcada */
    let selected = false;

    for (let key in this.state.data) {
      if (this.state.data[key] === true) {
        selected = true;
        break;
      }
    }

    if (!selected) {
      Modal.error({
        title: "Erro",
        content: "Selecione pelo menos uma das opções!"
      });
      return;
    }

    this.setState({
      loading: true
    });

    let formData = new FormData();
    formData.append("planilha", file);

    let data = {};

    for (let key in this.state.data) {
      if (this.state.data[key] === true) {
        data[key] = true;
      }
    }

    const every_offices = data["every_offices"];

    formData.append("options", JSON.stringify(data));
    formData.append("every_offices", every_offices);

    await api
      .post("/crawlers/busca_infos/", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(() => {
        Modal.success({
          title: "Atividade solicitada",
          content: (
            <div>
              Atividade solicitada com sucesso! Clique&nbsp;
              <a href="/atividades">aqui</a> para ver suas atividades.
            </div>
          )
        });
        document.getElementById("planilha").value = null;
      })
      .catch(error => {
        Modal.error({
          title: "Erro",
          content: handleError(error)
        });
      });

    this.setState({
      loading: false
    });
  };

  handleCheckboxChange = (event, value) => {
    let checked = event.target.checked;

    let data = this.state.data;
    data[value] = checked;

    this.setState({
      data
    });
  };

  render() {
    return (
      <Base title="Busca infos (HDI)">
        <div className="cw__title">Quais informações deseja buscar?</div>
        <br />
        <hr />
        <div>
          <Row gutter={8}>
            <Col sm={{ span: 5 }}>
              <div className="buscai__checkcontainer">
                <div className="buscai__check">
                  <Checkbox
                    onChange={event =>
                      this.handleCheckboxChange(event, "valor_causa")
                    }
                  >
                    Valor da causa
                  </Checkbox>
                </div>
                <div className="buscai__check">
                  <Checkbox
                    onChange={event =>
                      this.handleCheckboxChange(event, "numero_sinistro")
                    }
                  >
                    Número do sinistro
                  </Checkbox>
                </div>
                <div className="buscai__check">
                  <Checkbox
                    onChange={event =>
                      this.handleCheckboxChange(event, "coordenador")
                    }
                  >
                    Dados do coordenador
                  </Checkbox>
                </div>
              </div>
            </Col>
            <Col sm={{ span: 5 }}>
              <div className="buscai__checkcontainer">
                <div className="buscai__check">
                  <Checkbox
                    onChange={event =>
                      this.handleCheckboxChange(event, "congenere")
                    }
                  >
                    Congenere
                  </Checkbox>
                </div>
                <div className="buscai__check">
                  <Checkbox
                    onChange={event =>
                      this.handleCheckboxChange(event, "data_ocorrencia")
                    }
                  >
                    Data da ocorrência
                  </Checkbox>
                </div>
                <div className="buscai__check">
                  <Checkbox
                    onChange={event =>
                      this.handleCheckboxChange(event, "causa")
                    }
                  >
                    Causa
                  </Checkbox>
                </div>
              </div>
            </Col>
            <Col sm={{ span: 5 }}>
              <div className="buscai__checkcontainer">
                <div className="buscai__check">
                  <Checkbox
                    onChange={event =>
                      this.handleCheckboxChange(event, "desc_sinistro")
                    }
                  >
                    Descrição do sinistro
                  </Checkbox>
                </div>
                <div className="buscai__check">
                  <Checkbox
                    onChange={event => this.handleCheckboxChange(event, "bo")}
                  >
                    B.O
                  </Checkbox>
                </div>
                <div className="buscai__check">
                  <Checkbox
                    onChange={event =>
                      this.handleCheckboxChange(event, "veiculo")
                    }
                  >
                    Dados do veículo
                  </Checkbox>
                </div>
              </div>
            </Col>
            <Col sm={{ span: 5 }}>
              <div className="buscai__checkcontainer">
                <div className="buscai__check">
                  <Checkbox
                    onChange={event =>
                      this.handleCheckboxChange(event, "segurado")
                    }
                  >
                    Dados do segurado
                  </Checkbox>
                </div>
                <div className="buscai__check">
                  <Checkbox
                    onChange={event =>
                      this.handleCheckboxChange(event, "corretor")
                    }
                  >
                    Dados do corretor
                  </Checkbox>
                </div>
                <div className="buscai__check">
                  <Checkbox
                    onChange={event =>
                      this.handleCheckboxChange(event, "local_acidente")
                    }
                  >
                    Local do acidente
                  </Checkbox>
                </div>
              </div>
            </Col>
            <Col sm={{ span: 4 }}>
              <div className="buscai__checkcontainer">
                <div className="buscai__check">
                  <Checkbox
                    onChange={event =>
                      this.handleCheckboxChange(event, "acordo")
                    }
                  >
                    Verificar acordo
                  </Checkbox>
                </div>
              </div>
            </Col>
            <Col sm={{ span: 4 }}>
              <div className="buscai__checkcontainer">
                <div className="buscai__check">
                  <Checkbox
                    onChange={event =>
                      this.handleCheckboxChange(event, "every_offices")
                    }
                  >
                    Todos os escritórios
                  </Checkbox>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <hr />
        <div>
          <div className="cw__title">
            Selecione a planilha com as pastas na primeira coluna.
          </div>
          <div className="cw__inputs" style={{ margin: "15px" }}>
            <input id="planilha" type="file" />
            <Button
              type="primary"
              onClick={this.handleExecutar}
              style={{ marginLeft: "25px" }}
              loading={this.state.loading}
            >
              Executar
            </Button>
          </div>
        </div>
      </Base>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Crawlers/Buscainfo/index.js